var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8H44.5C46.3998 8 47.7743 8.00106 48.8225 8.14199C49.8563 8.28098 50.4975 8.54772 50.9749 9.02513C51.4523 9.50253 51.719 10.1437 51.858 11.1775C51.9989 12.2257 52 13.6002 52 15.5V44.5C52 46.3998 51.9989 47.7743 51.858 48.8225C51.719 49.8563 51.4523 50.4975 50.9749 50.9749C50.4975 51.4523 49.8563 51.719 48.8225 51.858C47.7743 51.9989 46.3998 52 44.5 52H15.5C13.6002 52 12.2257 51.9989 11.1775 51.858C10.1437 51.719 9.50253 51.4523 9.02513 50.9749C8.54772 50.4975 8.28098 49.8563 8.14199 48.8225C8.00106 47.7743 8 46.3998 8 44.5V15.5C8 13.6002 8.00106 12.2257 8.14199 11.1775C8.28098 10.1437 8.54772 9.50253 9.02513 9.02513C9.50253 8.54772 10.1437 8.28098 11.1775 8.14199C12.2257 8.00106 13.6002 8 15.5 8Z",
    stroke: "#E8A941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20L30 40",
    stroke: "#E8A941",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30L20 30",
    stroke: "#E8A941",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddPhoto);
export default __webpack_public_path__ + "static/media/icon-add-photo.f91fb8bb1c066b66a5afb675190fca96.svg";
export { ForwardRef as ReactComponent };